import * as React from 'react';
import { gql, useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import BeatLoader from 'react-spinners/BeatLoader';
import {
  Wrapper,
  Welcome,
  Title,
  Form,
  Label,
  Input,
  LoginButton,
} from '../studentLoginform/styles';
import { academicYear } from '../../../../helpers';
import { useExamsTypeAndSem } from '../../../../helpers/examTypeAndSemester';

export const InvigilatorLoginForm = ({ toggleModal }: { toggleModal: () => void }): JSX.Element => {
  const [passcode, setPasscode] = React.useState<string>('');
  const navigate = useNavigate();
  const passcodeInputRef = React.useRef<HTMLInputElement>(null);
  const examTypeAndSem = useExamsTypeAndSem();

  const SIGN_IN_INVIGILATOR = gql`
    mutation signInvigilator($passcode: String!) {
      signInInvigilator(passcode: $passcode) {
        token
      }
    }
  `;

  const [signInvigilator, { data, loading }] = useMutation(SIGN_IN_INVIGILATOR);

  React.useEffect(() => {
    const token = data?.signInInvigilator?.token;
    if (data && token) {
      localStorage.setItem('coe-invigilator-token', token);
      toggleModal();
      navigate('/invigilator', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleInvigilatorLogin = async (e: React.MouseEvent<HTMLElement>): Promise<void> => {
    e.preventDefault();
    if (passcode === '') {
      toast.warn('Please enter passcode first!');
      passcodeInputRef.current && passcodeInputRef.current.focus();
      return;
    }
    try {
      await signInvigilator({ variables: { passcode } });
    } catch (err) {
      toast.error(err.message || `Incorrect passcode. Contact CoE Examiner`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <Wrapper>
      <Welcome>Welcome</Welcome>
      <Title>
        {/* eslint-disable-next-line max-len*/}
        Log in to view your {examTypeAndSem && examTypeAndSem.examType.toLowerCase()}{' '}
        {examTypeAndSem?.semester} examination timetable for the {academicYear} academic year.
      </Title>
      <Form>
        <Label>Passcode</Label>
        <Input
          placeholder="Enter your passcode"
          className="focus:bg-gray-100"
          onChange={(e) => {
            setPasscode(e.target.value);
          }}
          value={passcode}
          ref={passcodeInputRef}
        />
        <LoginButton style={{ color: 'white' }} onClick={handleInvigilatorLogin}>
          {' '}
          {loading ? <BeatLoader color="#fff" size={18} /> : 'Log in'}
        </LoginButton>
      </Form>
    </Wrapper>
  );
};
